import React, { Component } from 'react';
import {Line, Chart} from 'react-chartjs-2';
import Loader from './nav/Loader';

import { connect } from "react-redux";
import { setTeamConsistencyInitialData } from "../actions/action_teamconsistency";
import { getTeamConsistencyData } from "../actions/action_teamconsistency";

class TeamConsistency extends Component {
  constructor(props) {
      super(props);
      this.getChart = this.getChart.bind(this);
  }
  componentDidMount() {
    this.props.getTeamConsistencyData({
      "team": Number(this.props.teamFilter),
      "year": Number(this.props.yearFilter)
    });
  }
  componentDidUpdate(prevProps){
    if(Number(prevProps.teamFilter) !== Number(this.props.teamFilter)
      || Number(prevProps.yearFilter) !== Number(this.props.yearFilter)){
      this.props.getTeamConsistencyData({
        "team": Number(this.props.teamFilter),
        "year": Number(this.props.yearFilter)
      });
    }
    var dark = document.body.classList.contains('dark-theme');
    if(prevProps.chartRegistered !== this.props.chartRegistered && this.props.chartRegistered === true){
      Chart.pluginService.register({
        afterDatasetsDraw: () => {
          if(this._child){
            let ctx = this._child.chartInstance.chart.ctx;
            ctx.font = "12px Verdana";
            ctx.fillStyle = dark ? "#aaa" : "#444444";
            ctx.textAlign = "center";
            ctx.textBaseline = "bottom";

            this._child.chartInstance.chart.config.data.datasets.forEach(function (dataset) {
              const dataArray = dataset.data;
              var keys = Object.keys(dataset._meta);
              keys.sort(function(a, b){return b-a});
              var indexNum = keys[0];
              if(dataset._meta[indexNum] !== undefined){
                if(dataset._meta[indexNum].hidden !== true){
                  dataset._meta[indexNum].data.forEach(function (line, index) {
                      ctx.fillText(dataArray[index], line._view.x, line._view.y-5);
                  });
                }
              }
            })
          }
        }
      });
    }
  }

  getChart() {
    if(this.props.teamFilter !== 0){
      return (
        <Line ref={child => {this._child = child;}} data={this.props.tcdata}
          width={100}
          height={50}
          options={{
            maintainAspectRatio: false,
            responsive: true,
            title:{
  						display: true,
  						text: ''
  					},
            legend: {
              labels: {
                fontColor: '#aaa',
              }
            },
  					tooltips: {
  						position: 'average',
  						mode: 'index',
  						intersect: false,
              titleFontSize: 20,
              bodyFontSize: 15,
              backgroundColor: 'rgba(0,0,0,1)',
  					},
          }}
        />
      );
    } else {
      return (
        <div>Please Pick a Team</div>
      );
    }
  }
  render() {
    if(!this.props.showLoader){
      return (
          <div className="chart-container">
            {this.getChart()}
          </div>
      );
    } else {
      return <Loader />;
    }
  }
}

function mapStateToProps(state) {
  return {
    teamFilter: state.main.teamFilter,
    yearFilter: state.main.yearFilter,
    tcdata: state.teamConsistency.tcdata,
    chartRegistered: state.teamConsistency.chartRegistered
  };
}

export default connect(mapStateToProps, { getTeamConsistencyData, setTeamConsistencyInitialData })(TeamConsistency);
